import React, { Component } from "react";
import { Layout, message } from "antd";
import "antd/dist/antd.css";
import "./App.css";
import Head from "../header/Header";
import Subscriptions from "../subscriptions/Subscriptions";
import Articles from "../articles/Articles";
import firebase, { auth, provider } from "../../firebase.js";
import Welcome from "../welcomePage/Welcome";
import Spinner from "../spinner/spinner";

const { Content } = Layout;
class App extends Component {
  state = {
    user: false,
    email: "",
    inputValue: null,
    selectId: null,
    favoriteArticles: [],
    uid: null,
  };
  componentDidMount() {
    auth.onAuthStateChanged(user => {
      if (user) {
        this.setState({ user, uid: user.uid });
        const itemsRef2 = firebase.database().ref(user.uid);
        itemsRef2.on("value", snapshot => {
          let items = snapshot.val();
          let newState = [];
          for (let item in items) {
            newState.push({
              id: item,
              title: items[item].title,
              doi: items[item].doi,
              user: items[item].user,
            });
          }
          this.setState({
            favoriteArticles: newState,
          });
        });
      } else {
        this.setState({ user: null });
      }
    });
  }

  newPropsArticles = body => {
    this.setState({ inputValue: body });
  };

  info = arg => {
    message.info(arg);
  };
  success = arg => {
    message.success(arg);
  };
  addToFavorites = (title, doi) => {
    let favoritesArray = this.state.favoriteArticles.concat();
    if (
      favoritesArray.filter(function(item) {
        return item.title === title;
      }).length > 0
    ) {
      this.info("Статья уже находится в избранном", 2);
      return;
    }
    const itemsRef = firebase.database().ref(this.state.uid);
    const item = {
      title: title,
      doi: doi,
      user: this.state.user.email,
      uid: this.state.uid,
    };
    itemsRef.push(item);
    const itemsRef2 = firebase.database().ref(this.state.uid);
    itemsRef2.on("value", snapshot => {
      let items = snapshot.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item,
          title: items[item].title,
          doi: items[item].doi,
          user: items[item].user,
        });
      }
      this.setState({
        favoriteArticles: newState,
      });
    });
    this.success("Статья добавлена в избранное", 2);
  };

  removeFavoriteItem = itemId => {
    const itemRef = firebase.database().ref(`/${this.state.uid}/${itemId}`);
    itemRef.remove().then(res => {
      this.success("Статья удалена из избранного", 2);
    });
    const itemsRef2 = firebase.database().ref(this.state.uid);
    itemsRef2.on("value", snapshot => {
      let items = snapshot.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item,
          title: items[item].title,
          doi: items[item].doi,
          user: items[item].user,
        });
      }
      this.setState({
        favoriteArticles: newState,
      });
    });
  };
  login = () => {
    this.setState({ user: false });
    auth.signInWithPopup(provider).then(result => {
      const user = result.user;
      this.setState({
        user,
      });
    });
  };
  logout = () => {
    this.setState({ user: false });
    auth.signOut().then(() => {
      this.setState({
        user: null,
      });
    });
  };
  render() {
    if (this.state.user === false) {
      return <Spinner />;
    }
    if (!this.state.user) {
      return (
        <Welcome
          logout={this.logout}
          login={this.login}
          user={this.state.user}
        />
      );
    }
    return (
      <Layout className="layoutContainer">
        <Head
          inputValue={this.newPropsArticles}
          user={this.state.user}
          logout={this.logout}
          login={this.login}
        />

        <Layout>
          <Content className="mainContent">
            <Subscriptions
              inputValue={this.newPropsArticles}
              data={this.state.favoriteArticles}
              user={this.state.user}
              deleteItem={this.removeFavoriteItem}
            />
            <Articles
              addFavorite={this.addToFavorites}
              value={this.state.inputValue}
            />
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default App;
